export const getAvatarVariantName = (page: number) =>
  page < 3
    ? 'classic'
    : page < 6
    ? 'bronze'
    : page < 9
    ? 'silver'
    : page < 12
    ? 'gold'
    : 'halloween';
